import { useEffect, useState } from 'react'
import { media } from '@chewy/kib-utilities'

type ChirpBreakpoint = 'xs' | 'sm' | 'md' | 'lg' | 'xl'

const getMatches = (query: string): boolean => {
  if (typeof window === 'undefined') return false
  return window.matchMedia(query).matches
}

export const useIsBelowBreakpoint = (breakpoint: ChirpBreakpoint): boolean => {
  const query = media.query(`min-${breakpoint}`)

  const [isBelow, setIsBelow] = useState(() => !getMatches(query))

  useEffect(() => {
    const mql = window.matchMedia(query)
    setIsBelow(!mql.matches)

    const handler = (e: MediaQueryListEvent) => setIsBelow(!e.matches)

    mql.addEventListener('change', handler)
    return () => mql.removeEventListener('change', handler)
  }, [query])

  return isBelow
}
